import type { ScoreBreakdown as Breakdown } from '../engine/types';
import { commas, signed } from '../utils/format';

export function ScoreBreakdown({ breakdown }: { breakdown: Breakdown }) {
  return (
    <div className="cv-breakdown">
      {breakdown.lines.map((line, i) => (
        <div className="cv-breakdown__line" key={i}>
          <span>
            {line.label}
            {line.display ? <span className="cv-faint"> {line.display}</span> : null}
          </span>
          <span
            className="cv-breakdown__val"
            data-neg={line.value < 0 ? 'true' : undefined}
            data-bonus={line.kind === 'bonus' || line.kind === 'multiplier' ? 'true' : undefined}
          >
            {signed(line.value)}
          </span>
        </div>
      ))}
      <div className="cv-breakdown__line" data-total="true">
        <span>Total</span>
        <span className="cv-breakdown__val">{commas(breakdown.total)}</span>
      </div>
    </div>
  );
}
